import { render } from "./ReservationPaymentForm.vue?vue&type=template&id=1d824f68"
import script from "./ReservationPaymentForm.vue?vue&type=script&lang=js"
export * from "./ReservationPaymentForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__